define('cartware/components/magento/product/type/configurable',[
	'jquery',
	'lodash',
	'cartware/components/_base'
],
function(
	$,
	_,
	Component
) {
	return Component.create({
		init: function() {
			this.patchPrototype();
		},

		patchPrototype: function() {
			if (_.get(window, "Product.Config") == null) {
				return null;
			}

			var $document = $(document);

			if (!Product.Config.prototype._advises_installed) {
				var _initialize = Product.Config.prototype.initialize;

				var self = this;

				Product.Config.prototype.dataProviders = null;

				Product.Config.prototype.registerDataProvider = function(dataProvider) {
					this.dataProviders.push(dataProvider);
				};

				Product.Config.prototype.unregisterDataProvider = function(dataProvider) {
					var index = this.dataProviders.indexOf(dataProvider);

					if (index >= 0) {
						delete this.dataProviders[index];
					}
				};

				Product.Config.prototype.initialize = function(config) {
					var separatorIndex = window.location.href.indexOf('#'),
						i;

					this.dataProviders = [];

					if (separatorIndex == -1) {
						if (this._configurable && "initialCriteria" in this._configurable) {
							config.defaultValues = this._generateDefaultValues(config);
						}
					}

					_initialize.apply(this, [config]);

					//for (i in this.state) {
					//	if (this.state.hasOwnProperty(i) && this.state[i] == false) {
					//		self.addToCartButton.addClass('disabled');
					//		break;
					//	}
					//}
				};

				Product.Config.prototype._generateDefaultValues = function(config) {
					return $.extend({}, this._configurable ? this._configurable.initialCriteria : {}, (config.defaultValues || {}));
				};

				var _configureElement = Product.Config.prototype.configureElement;
				Product.Config.prototype.configureElement = function(element) {
					_configureElement.apply(this, arguments);

					// clean state
					_.forEach(this.settings, function(el) {
						this.state[el.config.id] = (el.value && el.value == ~~el.value) ? el.value : false;
					}, this);

					var selectionComplete = _.all(this.settings, function(select) {
						return select.value;
					});

					$document.trigger('product/configure', [element, this, selectionComplete]);
					this.__onConfigure(element);
				};

				var _fillSelect = Product.Config.prototype.fillSelect;
				Product.Config.prototype.fillSelect = function(element) {
					//var attributeId = element.id.replace(/[a-z]*/, '');
					_fillSelect.apply(this, arguments);
					$(element).trigger('attribute/fillSelect');
				};

				var _reloadOptionLabels = Product.Config.prototype.reloadOptionLabels;
				Product.Config.prototype.reloadOptionLabels = function(element) {
					_reloadOptionLabels.apply(this, arguments);
					$(element).trigger('attribute/reloadOptionLabels');
				};

				var _resetChildren = Product.Config.prototype.resetChildren;
				Product.Config.prototype.resetChildren = function(element) {
					_resetChildren.apply(this, arguments);
					if (element.childSettings) {
						for (var i = 0; i < element.childSettings.length; i++) {
							$(element.childSettings[i]).trigger('attribute/reset');
						}
					}
				};

				//var _configureForValues = Product.Config.prototype.configureForValues;
				var _configureForValues = function () {
					if (this.values) {
						this.settings.each(function(element){
							var attributeId = element.attributeId,
								valueUndefined = (typeof(this.values[attributeId]) == 'undefined');

							if (valueUndefined) {
								throw $break;
							}

							element.value = valueUndefined ? '' : this.values[attributeId];

							if (!element.value) {
								if ("undefined" !== console.error) {
									console.error("Given configurable options are invalid");
								}

								throw $break;
							}

							this.configureElement(element);
						}.bind(this));
					}
				};

				Product.Config.prototype.configureForValues = function() {
					var values = {}
						, count = 0;

					if (this.values) {
						this.settings.each(function(element) {
							var attributeId = element.attributeId;
							if (typeof(this.values[attributeId]) != 'undefined') {
								values[attributeId] = this.values[attributeId];
								++count;
							}
						}, this);

						if (!count) values = this._generateDefaultValues(this.config);

						this.values = values;
					}

					if (count > 0) _configureForValues.apply(this, arguments);
					$document.trigger('product/configureForValues', [this]);
				};

				Product.Config.prototype.__currentGallerySimple = null;
				Product.Config.prototype.__currentSimple = null;

				Product.Config.prototype.__onConfigure = function() {
					var self = this
						, simples = _.get(this._configurable, "simples", {})
						, gallerySimple = null
						, targetSimple = null
						, simpleConditions = _.assign.apply(
							null,
							_.filter(
								_.map(
									_.get(this._configurable, "super_media_attributes", []),
									function(attributeId) {
										var obj = {};

										if (!_.get(self.state, attributeId, false)) {
											return false;
										}

										obj[attributeId] = self.state[attributeId];
										return obj;
									}
								)
							)
						)
						, conditions = {}
						, selects = this.settings;

					_.forEach(selects, function(node) {
						var select = $(node)
							, value = select.val() | 0
							, attributeId = select.prop('id').replace(/[a-z]*/, '');

						conditions[attributeId] = value;
					});

					var simplesArray = _(simples).map().sortBy("priority").value().reverse();

					// Find simple which meets the configured conditions
					_.forEach(simplesArray, function(simple) {
						var galleryConditionsMet = true
							, conditionsMet = true;

						_.forEach(simpleConditions, function(value, attributeId) {
							if (_.get(simple.attributes, [attributeId, "value"], null) != value) {
								galleryConditionsMet = false;
								return false;
							}
						});

						if (galleryConditionsMet) {
							gallerySimple = simple;
						}

						_.forEach(conditions, function(value, attributeId) {
							if (_.get(simple.attributes, [attributeId, "value"], null) != value) {
								conditionsMet = false;
								return false;
							}
						});

						if (conditionsMet) {
							targetSimple = simple;
						}
					});

					if (null === this.__currentGallerySimple || gallerySimple !== this.__currentGallerySimple) {
						this.__currentGallerySimple = gallerySimple;
						//$document.trigger('product/changeGalleryImage', [this.__currentGallerySimple['3dpicture']]);
						$document.trigger('product/changeGallerySimple', [this.__currentGallerySimple]);
					}

					if (null === this.__currentSimple || targetSimple !== this.__currentSimple) {
						this.__currentSimple = targetSimple;
						$document.trigger('product/changeSimple', [this.__currentSimple]);
					}
				};

				Product.Config.prototype._advises_installed = true;
			}
		}
	});
});
